import { SEARCH_RESULT_SELECTED } from './constants/AmplitudeEvent';

const getMockInstance = () => {
  return {
    init: () => {},
    logEvent: (eventName, params, callback) => {
      if (callback) {
        callback();
      }
    },
    setUserId: () => {},
    regenerateDeviceId: () => {}
  };
};

const getAmplitudeInstance = () => {
  // getInstance should work seamlessly in alpha and production. In non-alpha|production
  // environments getInstance returns a mock instance where all methods are noops.
  // To enable Amplitude in development uncomment the second `api_key = ...` in the ApplicationController

  let instance = getMockInstance();

  if (window.amplitude) {
    instance = window.amplitude.getInstance();
  }

  return instance;
};

const logSearchResultSelectedEvent = (query, position, result, location) => {
  const amplitudeEventParams = {
    'query length': query ? query.length : 0,
    position,
    type: result.type,
    location
  };

  getAmplitudeInstance().logEvent(SEARCH_RESULT_SELECTED, amplitudeEventParams);
};

export { getAmplitudeInstance, logSearchResultSelectedEvent };
